import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Style/typo.css";
import "./assets/css/style-video.css";
import NavButton from "../homepage/header-banner/TopNavButton";
import Footer from "../homepage/footer/Footer";
import DeskIcon1 from "./assets/image/desk_icon1.png";
import DeskIcon2 from "./assets/image/desk_icon2.png";
import DeskIcon3 from "./assets/image/desk_icon3.png";
// import DeskIcon4 from "./assets/image/desk_icon4.png";
// import DeskIcon5 from "./assets/image/desk_icon5.png";
import DeskIcon6 from "./assets/image/desk_icon6.png";
import DeskIcon7 from "./assets/image/desk_icon7.png";
import VideoImg from "./assets/image/video-img.png";
import VideoFeatureImg1 from "./assets/image/video-feature-img1.png";
import VideoImage from "./assets/image/video-image.png";
import VideoImage1 from "./assets/image/video-image1.png";
import VideoImage2 from "./assets/image/video-image2.png";
import VideoImage3 from "./assets/image/video-image3.png";
// import VideoFeatureImg2 from "./assets/image/video-feature-img2.png";
// import VideoFeatureImg3 from "./assets/image/video-feature-img3.png";
import FadeInSection from "../container/component/Fadeanimation/FadeInSection";

export function VideoBanner() {
    const scrollToSection = (id, offset = 80) => {
        const el = document.getElementById(id);
        if (!el) return;
        const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: "smooth" });
    };

    return (
        <div className="video">
            <div className="video-banner">
                <div className="fit-video-box">
                    <FadeInSection>
                        <div className="video-wrap">
                            <div className="video-box video-box-left">
                                <div className="video-banner-left">
                                    <div>
                                        <p className="typo-32-mb wh-color">AI 기능이 추가된 한비로 Talk 화상회의</p>
                                        <p className="typo-16 wh-color">
                                            언제 어디서나 한비로 메신저를 통한 실시간 화상회의 참여!
                                            <br />
                                            더 이상 화상회의 기록을 별도로 정리하지 않아도 됩니다.
                                            <br />
                                            AI가 화상 회의 내용을 핵심 요약하고, 음성을 자동으로 텍스트로 변환합니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="video-box video-box-right">
                                <div className="video-box-img">
                                    <img src="https://hanbiro.com/assets/images/cloud/video-conference-banner-sm-1.png" alt="video1" />
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>
        </div>
    );
}

export function VideoBody() {
    return (
        <div>
            <div className="video-block video-ft-block">
                <div className="fit-video-box">
                    <FadeInSection>
                        <div className="video-feature">
                            <div className="video-title-feature">
                                <p className="typo-32 typo-medium">AI 기능</p>
                            </div>

                            <div className="video-feature-block video-feature-block-item">
                                <div className="video-feature-box">
                                    <div className="video-feature-img">
                                        <img className="video-img-icon" src="https://hanbiro.com/assets/images/cloud/ai-video-conference.png" alt="" />
                                    </div>
                                    <div className="video-feature-text">
                                        <p className="typo-16 typo-medium">화상회의 요약</p>
                                        <p className="typo-16 video-desc">AI가 회의 내용을 분석하여 핵심 내용을 요약</p>
                                    </div>
                                </div>
                                <div className="video-feature-box">
                                    <div className="video-feature-img">
                                        <img className="video-img-icon" src="https://hanbiro.com/assets/images/cloud/ai-video-conference.png" alt="" />
                                    </div>
                                    <div className="video-feature-text">
                                        <p className="typo-16 typo-medium">화상회의 음성 텍스트 변환</p>
                                        <p className="typo-16 video-desc">회상 회의 음성을 자동으로 텍스트로 변환하고 히스토리 관리</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>

            <div className="video-block" id="video-ai-feature">
                <div className="fit-video-box">
                    <div className="video-feature">
                        <div className="video-title">
                            <p className="typo-32 typo-medium">AI 전화 기능</p>
                        </div>
                        <FadeInSection>
                            <div className="video-content">
                                <div className="video-item">
                                    <div className="video-item-content">
                                        <div className="video-item-icon">
                                            <p className="typo-21 typo-medium">AI 화상회의 요약 및 음성 텍스트 변환</p>
                                            <div className="video-desc-content">
                                                <p className="typo-16 video-desc">화상 회의 내용을 AI가 자동으로 분석하여 주요 내용을 요약합니다.</p>
                                                <p className="typo-16 video-desc">음성을 실시간으로 텍스트로 변환하여 기록으로 확인할 수 있습니다.</p>
                                                <p className="typo-16 video-desc">해당 기록은 화상회의 히스토리 관리 메뉴를 통해 언제든지 확인이 가능합니다.</p>
                                            </div>
                                        </div>
                                        <div className="video-item-img">
                                            <img src="https://hanbiro.com/assets/images/cloud/video-conference-demo/demo-meeting-notes.png" />
                                        </div>
                                    </div>
                                </div>

                                <div className="video-item">
                                    <div className="video-item-content">
                                        <div className="video-item-icon">
                                            <p className="typo-21 typo-medium">AI 화상회의 언어 설정</p>
                                            <div className="video-desc-content">
                                                <p className="typo-16 video-desc">화상 회의 화면에서 ‘설정’ 아이콘을 눌러 참여자의 음성 언어를 선택합니다.</p>
                                                <p className="typo-16 video-desc">AI가 사용자가 사용하는 언어를 인식하여 텍스트로 변환하는데 사용되며,</p>
                                                <p className="typo-16 video-desc">이를 통해 더 정확하고 향상된 결과를 얻을 수 있습니다.</p>
                                            </div>
                                        </div>
                                        <div className="video-item-img">
                                            <img src="https://hanbiro.com/assets/images/cloud/video-conference-demo/demo-ai.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>

                        <FadeInSection>
                            <div className="video-content ">
                                <div className="video-item">
                                    <div className="video-item-content">
                                        <div className="video-item-icon">
                                            <p className="typo-21 typo-medium">Hanbiro Talk2 메신저에서 바로 시작</p>
                                            <div className="video-desc-content">
                                                <p className="typo-16 video-desc">메신저 대화방 화면의 ‘화상 회의’ 아이콘을 클릭하여</p>
                                                <p className="typo-16 video-desc">언제 어디서나 바로 화상 회의에 참여가 가능합니다.</p>
                                            </div>
                                        </div>
                                        <div className="video-item-img">
                                            <img src="https://hanbiro.com/assets/images/cloud/video-conference-demo/demo-main-screen-1.png" />
                                        </div>
                                    </div>
                                </div>

                                <div className="video-item">
                                    <div className="video-item-content">
                                        <div className="video-item-icon">
                                            <p className="typo-21 typo-medium">손님 초대</p>
                                            <div className="video-desc-content">
                                                <p className="typo-16 video-desc">화상회의 화면에서 ‘링크’아이콘을 눌러 손님 초대 링크를 생성합니다.</p>
                                                <p className="typo-16 video-desc">링크를 복사하거나, 이메일 눌러 바로 초대 메일을 발송합니다.</p>
                                            </div>
                                        </div>
                                        <div className="video-item-img">
                                            <img src="https://hanbiro.com/assets/images/cloud/video-conference-demo/demo-conference-invite-guest.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>

                        <FadeInSection>
                            <div className="video-content">
                                <div className="video-item">
                                    <div className="video-item-content">
                                        <div className="video-item-icon">
                                            <p className="typo-21 typo-medium">최대 6명 화면 표시</p>
                                            <div className="video-desc-content">
                                                <p className="typo-16 video-desc">화상 회의 참가자는 화면에 최대 6명까지 표시됩니다.</p>
                                                <p className="typo-16 video-desc">음성이 감지된 참가자는 화면에 테두리로 표시되어 현재 말하고 있는 사용자를</p>
                                                <p className="typo-16 video-desc">쉽게 확인할 수 있습니다.</p>
                                            </div>
                                        </div>
                                        <div className="video-item-img">
                                            <img src="https://hanbiro.com/assets/images/cloud/video-conference-demo/demo-video-conference.png" />
                                        </div>
                                    </div>
                                </div>

                                <div className="video-item">
                                    <div className="video-item-content">
                                        <div className="video-item-icon">
                                            <p className="typo-21 typo-medium">화면 공유</p>
                                            <div className="video-desc-content">
                                                <p className="typo-16 video-desc">화상회의 화면에서 ‘공유’ 아이콘을 눌러 내가 보는 화면을 참여자와 공유합니다.</p>
                                                <p className="typo-16 video-desc"> • Screen : 모니터 화면 전체를 공유합니다.</p>
                                                <p className="typo-16 video-desc"> • Window : 현재 실행 중인 프로그램(창)만 선택하여 공유할 수 있습니다.</p>
                                            </div>
                                        </div>
                                        <div className="video-item-img">
                                            <img src="https://hanbiro.com/assets/images/cloud/video-conference-demo/demo-screen-sharing.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>
                    </div>
                </div>
            </div>

            <div className="video-block" id="video-key-feature">
                <div className="fit-video-box">
                    <FadeInSection>
                        <div className="video-feature">
                            <div className="video-title">
                                <p className="typo-32 typo-medium">화상회의 특장점</p>
                            </div>
                            <div className="video-feature-wrap">
                                <div className="video-feature-block">
                                    <div className="video-feature-box">
                                        <div className="video-feature-img video-ft-icon">
                                            <UsersMedicalIcon />
                                        </div>
                                        <div className="video-feature-text">
                                            <p className="typo-16 typo-medium">누구나 쉽게 생성</p>
                                            <p className="typo-16 video-desc">메신저 대화방에서 클릭 한 번으로 생성</p>
                                        </div>
                                    </div>
                                    <div className="video-feature-box">
                                        <div className="video-feature-img video-ft-icon">
                                            <ArrowPointerIcon />
                                        </div>
                                        <div className="video-feature-text">
                                            <p className="typo-16 typo-medium">메신저 대화방에서 클릭 한 번으로 생성</p>
                                            <p className="typo-16 video-desc">웹 기반으로 별도의 설치 프로그램 없이 외부 사용자도 <br/>클릭 한 번으로</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="video-feature-block">
                                    <div className="video-feature-box">
                                        <div className="video-feature-img video-ft-icon">
                                            <UsersViewfinderIcon />
                                        </div>
                                        <div className="video-feature-text">
                                            <p className="typo-16 typo-medium">실시간 화면 공유</p>
                                            <p className="typo-16 video-desc">PC화면 공유로 프리젠테이션이나 원격 교육 가능</p>
                                        </div>
                                    </div>
                                    <div className="video-feature-box">
                                        <div className="video-feature-img video-ft-icon">
                                            <MobileScreenIcon />
                                        </div>
                                        <div className="video-feature-text">
                                            <p className="typo-16 typo-medium">모바일 지원</p>
                                            <p className="typo-16 video-desc">모바일 기기에서도 화상회의 참석 가능</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>
        </div>
    );
}

export function VideoContent() {
    return (
        <>
            <VideoBanner />
            <VideoBody />
        </>
    );
}

function VideoConference() {
    useEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <NavButton
                lang="ko"
                option={{
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061FF" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />
            <VideoContent />
            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

export default VideoConference;

export const UsersViewfinderIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" fill="currentColor">
        <path d="M48 48l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 0C14.3 0 0 14.3 0 32L0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7l56.1 0c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4l-69.3 0zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6l56.1 0zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1l-80 0c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104c0-17.7-14.3-32-32-32L504 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464l0-88c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 480c0 17.7 14.3 32 32 32l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c17.7 0 32-14.3 32-32l0-104c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0z"/>
    </svg>
);

export const UsersMedicalIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" fill="currentColor">
        <path d="M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7l-42.7 0C47.8 192 0 239.8 0 298.7zM405.3 320l77.4 0c6.6-18.6 24.4-32 45.3-32l32 0c20.9 0 38.7 13.4 45.3 32l13.4 0c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96c.2 0 .4 0 .7 0zM416 400c0-14.6 6.5-27.7 16.9-36.5C416.3 356.1 398 352 378.7 352l-117.3 0C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l328.1 0c-1.8-5-2.7-10.4-2.7-16l0-16-16 0c-26.5 0-48-21.5-48-48l0-32zm0-176a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm96 112l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"/>
    </svg>
);

export const MobileScreenIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor">
        <path d="M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM144 448c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM304 64L80 64l0 320 224 0 0-320z"/>
    </svg>
);

export const ArrowPointerIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor">
        <path d="M0 55.2L0 426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320l118.1 0c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z"/>
    </svg>
);
